// components/PomServiceSection.jsx
import React from "react";

export default function PomServiceSection() {
  return (
    <section className="bg-white py-20 px-4" id="pom">
      <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-10">
        {/* P.O.M. Service */}
        <div className="md:col-span-2">
          <h2 className="text-3xl font-extrabold text-neutral-900 mb-4">P.O.M. Service</h2>
          <p className="text-lg font-semibold text-neutral-800 mb-2">
            P.O.M. stands for Peace-of-Mind. This service allows you or your office to contact us at any time. In this we guarantee.
          </p>
          <ul className="list-disc pl-6 space-y-3 text-gray-700 mt-4">
            <li>All of your devices are functional</li>
            <li>Monitoring of your systems to prevent malfunction and preemptively detect errors</li>
            <li>Free consultation for new projects</li>
            <li>Any system replaced by us is covered by warranty for the life of the device</li>
            <li>If it breaks, we will replace it at no additional charge</li>
            <li>Regular backups to ensure your data is maintained</li>
            <li>1 hour recovery in the event of system failure or compromise</li>
          </ul>
        </div>

        {/* ST Warranty Box */}
        <div className="bg-gradient-to-b from-orange-500 to-orange-700 text-white p-6 rounded-lg shadow-lg">
          <h3 className="text-xl font-extrabold uppercase mb-4">ST Warranty</h3>
          <p className="font-semibold mb-4 text-sm leading-relaxed">
            Smartguy Technologies Warranty Service will provide you with a special guarantee beyond the manufacturer’s warranty. 
            We will replace any broken device for the life of your contract with a device of similar specs. We cover:
          </p>
          <ul className="list-disc list-inside font-bold text-sm space-y-1">
            <li>Televisions</li>
            <li>Cameras</li>
            <li>Gaming Consoles</li>
            <li>Desktops</li>
            <li>Laptops</li>
            <li>and more...</li>
          </ul>
        </div>
      </div>
    </section>
  );
}
